<div class="productlink-cont p-2">
    <div class="d-flex justify-content-between align-items-center">
        <span class="productlink-title">{{ "PRODUCT_LINK_COMPONENT_TITLE" | translate }}</span>
        <button class="productlink-delete" (click)="onProductLinkDelete()">
            <img src="assets/img/trash.png" class="delete-img" />
        </button>
    </div>
    <form class="w-100 mt-3">
        <ng-multiselect-dropdown
            [placeholder]="'PRODUCT_LINK_COMPONENT_PROD_PLACEHOLDER' | translate"
            [data]="products"
            [(ngModel)]="selectedItems"
            [settings]="dropdownSettings"
            (onSelect)="onItemSelect($event)"
            name="photosphere-prods"
        >
        </ng-multiselect-dropdown>
    </form>
    <div class="d-flex justify-content-center mt-3">
        <button class="btn w-75 green-btn" [disabled]="selectedItems === null" (click)="onProductLinkSave()">
            {{ "PRODUCT_LINK_COMPONENT_SAVE" | translate }}
        </button>
    </div>
    <div class="d-flex justify-content-center mt-3">
        <button class="btn w-75 green-btn" (click)="onCloseClick()">
            {{ "PRODUCT_LINK_COMPONENT_CLOSE" | translate }}
        </button>
    </div>
</div>
